import { Translation } from 'react-i18next';
import wemeetClient from '@utils/wemeetClient';
import { HostKickOutReason, UserItem, LeaveReason } from '@tencent/wemeet-websdk-next';
import { openDialog } from '@component/dialog';

import { gotoHomePage } from '@utils/navigate';
import { atou, wemeetBeaconReport } from '@tencent/web-base';

/**
 * kickout 回调操作
 *
 */
interface KickoutParams {
  kick_out: {
    '@xmlns': string;
    meeting_code: string;
    custom_data?: string;
    meeting_id: string;
    kicker: UserItem;
    reason: {
      '@code': HostKickOutReason;
      __value: string;
    };
  };
}

export const handleKickout = (params: KickoutParams, isCreator: boolean): void => {
  const data = params?.kick_out;
  if (!data) {
    return;
  }

  if (data.reason['@code'] === HostKickOutReason.sameUserKick) {
    // 在 push-serive 已经自动退房了，应用层只需要打开弹窗回到首页

    openDialog({
      dialogId: 'removeMeeting',
      title: <Translation>{(t) => t('移出会议')}</Translation>,
      content: <Translation>{(t) => t('您已经在其他设备加入会议，当前设备被移出会议')}</Translation>,
      btnConfigs: [
        {
          type: 'primary',
          text: <Translation>{(t) => t('知道了')}</Translation>,
          callback: () => {
            gotoHomePage();
          },
        },
      ],
    });

    return;
  }

  if (data.reason['@code'] === HostKickOutReason.dissolve) {
    if (data?.custom_data) {
      let dialogInfo = {
        title: '',
      };
      try {
        dialogInfo = JSON.parse(atou(data?.custom_data));
      } catch (error) {
        window.aegis.report(`parse custom_data error: ${error}`);
      }
      wemeetBeaconReport('e#web_meeting#limit_end#exposure', {
        is_creator: isCreator ? '1' : '0',
      });
      openDialog({
        dialogId: 'meetingEnded',
        title: <Translation>{(t) => t('会议已结束')}</Translation>,
        content: dialogInfo?.title,
        btnConfigs: [
          {
            type: 'primary',
            text: <Translation>{(t) => t('知道了')}</Translation>,
            callback: () => {
              gotoHomePage();
            },
          },
        ],
      });
      return;
    }

    openDialog({
      dialogId: 'meetingEnded',
      title: <Translation>{(t) => t('会议已结束')}</Translation>,
      btnConfigs: [
        {
          type: 'primary',
          text: <Translation>{(t) => t('知道了')}</Translation>,
          callback: () => {
            gotoHomePage();
          },
        },
      ],
    });
  }

  if (data.reason['@code'] === HostKickOutReason.normal) {
    openDialog({
      dialogId: 'hostKickout',
      title: <Translation>{(t) => t('移出会议')}</Translation>,
      content: <Translation>{(t) => t('你已经被主持人移出会议')}</Translation>,
      btnConfigs: [
        {
          type: 'primary',
          text: <Translation>{(t) => t('知道了')}</Translation>,
          callback: () => {
            gotoHomePage();
          },
        },
      ],
    });
  }

  if (data.reason['@code'] === '4015') {
    openDialog({
      dialogId: 'hostKickout',
      title: <Translation>{(t) => t('移出会议')}</Translation>,
      content: data.reason.__value,
      btnConfigs: [
        {
          type: 'primary',
          text: <Translation>{(t) => t('知道了')}</Translation>,
          callback: async () => {
            await wemeetClient.meetingCtrl.leaveMeeting(LeaveReason.SELF);
            gotoHomePage();
          },
        },
      ],
    });
  }
};
